import { Box, Typography, Divider } from '@mui/material';


function Experiences({ workExperiences, capitalizeWords }) {
    console.log(workExperiences);
    // Handle new API structure where workExperiences is directly an object with company names as keys
    const workExperiencesData = workExperiences && typeof workExperiences === 'object' && !Array.isArray(workExperiences) 
      ? workExperiences 
      : (workExperiences?.workExperience || null);
    
    const isNewFormat = workExperiencesData && typeof workExperiencesData === 'object' && !Array.isArray(workExperiencesData);
    
    if (!workExperiencesData || Object.keys(workExperiencesData).length === 0) {
        return null;
    }

    if (isNewFormat) {
        // New format: object with companies as keys
        return (
            <Box sx={{ mx: 2 }}>
                <Typography variant="h5" sx={{ color: '#666', mb: 2 }}>Work Experience</Typography>
                <Box sx={{ mb: 2, mx: 2 }}>
                    {Object.entries(workExperiencesData).map(([companyName, positions], companyIndex) => (
                        <Box sx={{ mb: 3 }} key={companyIndex}>
                            <Typography variant="h6" sx={{ color: '#444', fontWeight: 600, mb: 1 }}>
                                {capitalizeWords(companyName)}
                            </Typography>
                            {Array.isArray(positions) && positions.map((position, positionIndex) => (
                                <Box sx={{ mb: 2, ml: 2 }} key={positionIndex}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, flexWrap: 'wrap' }}>
                                        <Typography variant="body1" sx={{ color: '#888', fontSize: '1.1rem', fontWeight: 600, mb: 0.5 }}>
                                            {capitalizeWords(position.title)}
                                        </Typography>
                                        <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                            {position.tenure}
                                        </Typography>
                                    </Box>
                            
                                    {position.summary && (
                                        <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', mt: 0.5, fontWeight: 500 }}>
                                            <b>Summary:</b> {position.summary}
                                        </Typography>
                                    )}
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 5, mt: 0.5, flexWrap: 'wrap' }}>
                                        {position.location && (
                                            <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                                <b>Location:</b> {capitalizeWords(position.location)}
                                            </Typography>
                                        )}
                                        {position.industry && (
                                            <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                                <b>Industry:</b> {capitalizeWords(position.industry)}
                                            </Typography>
                                        )}
                                    </Box>
                                    {positionIndex < positions.length - 1 && <Divider sx={{ mb: 2, mt: 2, mx: 4 }} />}
                                </Box>
                            ))}
                            {companyIndex < Object.keys(workExperiencesData).length - 1 && <Divider sx={{ mb: 2, mt: 2 }} />}
                        </Box>
                    ))}
                </Box>
                {/* <Box sx={{ mb: 2, mx: 2 }}>
                    {Object.entries(workExperiencesData).map((company, companyIndex) => (
                        <Box sx={{ mb: 3 }} key={companyIndex}>
                            <Typography variant="h6" sx={{ color: '#444', fontWeight: 600, mb: 1 }}>
                                {capitalizeWords(company)}
                            </Typography>
                            {company.positions.map((position, positionIndex) => (
                                <Box sx={{ mb: 2, ml: 2 }} key={positionIndex}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                        <Typography variant="body1" sx={{ color: '#888', fontSize: '1.1rem', fontWeight: 600, mb: 0.5 }}>
                                            {capitalizeWords(position.title)}
                                        </Typography>
                                        <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                            {position.tenure}
                                        </Typography>
                                    </Box>
                            
                                    {position.summary && (
                                        <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', mt: 0.5, fontWeight: 500 }}>
                                            <b>Summary:</b> {position.summary}
                                        </Typography>
                                    )}
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 5, mt: 0.5 }}>
                                        {position.location && (
                                            <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                                <b>Location:</b> {capitalizeWords(position.location)}
                                            </Typography>
                                        )}
                                        {position.industry && (
                                            <Typography variant="subtitle2" sx={{ color: '#888', fontSize: '1rem', fontWeight: 500, mb: 0.5 }}>
                                                <b>Industry:</b> {capitalizeWords(position.industry)}
                                            </Typography>
                                        )}
                                    </Box>
                                    {positionIndex < company.positions.length - 1 && ( <Divider sx={{ mb: 2, mt: 2, mx: 4 }} /> )}
                                </Box>
                            ))}
                            {companyIndex < Object.keys(workExperiencesData).length - 1 && (<Divider sx={{ mb: 2, mt: 2 }} /> )}
                        </Box>
                    ))}
                </Box> */}
            </Box>
        );
    } else {
        // Old format: array of experiences
        return (
            <Box sx={{ mx: 2 }}>
                <Typography variant="h5" sx={{ color: '#666', mb: 2 }}>Work Experience</Typography>
                <Box sx={{ mb: 2 }}>
                    {workExperiencesData.map((experience, index) => (
                        <Box sx={{ mb: 2 }} key={index}>
                            <Typography variant="h6" sx={{ color: '#888' } }>
                                {capitalizeWords(experience.title)} - {capitalizeWords(experience.company)}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#888' }}>{experience.tenure}</Typography>
                            {experience.location && (
                                <Typography variant="body2" sx={{ color: '#888' }}>Location: {capitalizeWords(experience.location)}</Typography>
                            )}
                            <Typography variant="body1" sx={{ color: '#888' }}>{experience.summary}</Typography>
                            <Divider sx={{ mb: 2, mt: 2 }} />
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    }
}

export default Experiences;